import { all, put, call, takeEvery, takeLatest } from "redux-saga/effects";
import api_service from "../../network/api_callbacks";
import {
    GET_SUBCATEGORIES_REQUEST,
    getSubcategoriesSuccess,
    getSubcategoriesFailure
} from "../actions/getSubcategories"

function* getSubcategoriesSaga(action) {
    console.log(action)
    try {
        const response = yield call(api_service.getSubcategories, action.payload);
        yield put(getSubcategoriesSuccess(response));
    } catch (err) {
        console.log(err);
        yield put(getSubcategoriesFailure(err.response?.data?.message || 'failed'));
    }
}

export default function* watchGetSubcategoriesSaga() {
    yield takeEvery(GET_SUBCATEGORIES_REQUEST, getSubcategoriesSaga);
}
